module.exports = __webpack_public_path__ + "static/media/favorites.c2406227.svg";